import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PercorsiComponent } from './percorsi.component';

const routes: Routes = [
  { path: '',  component: PercorsiComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PercorsiRoutingModule { }